import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { loadConnectAndInitialize } from '@stripe/connect-js';
import { AccountService } from 'src/app/pages/account/services/account.service';
import { environment } from 'src/environments/environment';
import { FlexModule } from '@angular/flex-layout/flex';
import { NgIf } from '@angular/common';

@Component({
	selector: 'app-stripe-embeded',
	templateUrl: './stripe-embeded.component.html',
	styleUrls: ['./stripe-embeded.component.scss'],
	standalone: true,
	imports: [FlexModule, NgIf],
})
export class StripeEmbededComponent implements OnInit {
	accountOnboardComponent: any;
	responseData: any;
	stripeKey: string = 'EU';
	platform: any;
	isPayoutSettingsFlow: boolean = false;

	constructor(private _accountService: AccountService, public router: Router) {}

	async ngOnInit() {
		this.isPayoutSettingsFlow = this.router.url.includes(
			'profile/payout-settings/account_onboarding'
		);
		try {
			const clientSecret = await this.fetchClientSecretFromBackend();

			const stripeConnectInstance = loadConnectAndInitialize({
				publishableKey: this.stripeKey,
				fetchClientSecret: async () => clientSecret,
				locale: this._accountService.getLocaleId(),
				appearance: {
					variables: {
						fontFamily: 'Ideal Sans, system-ui, sans-serif',

						// Headings
						headingXlFontSize: '20px',
						headingXlFontWeight: '500',
						headingLgFontSize: '20px',
						headingLgFontWeight: '500',
						headingMdFontSize: '20px',
						headingMdFontWeight: '500',
						headingSmFontSize: '18px',
						headingSmFontWeight: '400',
						headingXsFontWeight: '400',

						headingXlTextTransform: 'capitalize',
						headingLgTextTransform: 'capitalize',
						headingMdTextTransform: 'capitalize',
						headingSmTextTransform: 'capitalize',
						headingXsTextTransform: 'capitalize',

						// Button styles
						buttonBorderRadius: '2px',
						buttonPrimaryColorBackground: '#363396',
						buttonPrimaryColorText: '#ffffff',
						buttonSecondaryColorBackground: '#ffffff',
						buttonSecondaryColorBorder: '#363396',
						buttonSecondaryColorText: '#363396',

						// General colors
						colorPrimary: '#32BF55',
						colorText: '#353535',
						colorDanger: '#FF5252',

						// Action links
						actionPrimaryColorText: '#363396',
						actionPrimaryTextDecorationColor: '#363396',
						actionSecondaryColorText: '#353535',
						actionSecondaryTextDecorationLine: 'none',
						actionSecondaryTextDecorationColor: '#353535',

						// Badge styles
						badgeNeutralColorText: '#353535',
						badgeSuccessColorBackground: '#32BF55',
						badgeSuccessColorBorder: '#32BF55',
						badgeSuccessColorText: '#353535',
						badgeDangerColorBackground: '#FF5252',
						badgeDangerColorText: '#353535',
						badgeWarningColorBackground: '#FFFCEB',
						badgeWarningColorBorder: '#FFBD14',
						badgeWarningColorText: '#353535',
					},
				},
			});

			this.accountOnboardComponent =
				stripeConnectInstance.create('account-onboarding');

			const container = document.getElementById('container');
			if (container) {
				container.appendChild(this.accountOnboardComponent);
			} else {
				console.error("Container with ID 'container' not found.");
			}

			this.accountOnboardComponent.setOnExit(() => {
				const currentUrl = this.router.url;
				if (currentUrl.includes('fundraising/country')) {
					this.router.navigate(['/fundraising/create']);
				} else {
					this.router.navigate(['/profile/payout-settings']);
				}
			});
		} catch (error: any) {
			console.error('Error initializing Stripe Connect:', error.message);
		}
	}

	private async fetchClientSecretFromBackend(): Promise<string> {
		try {
			const isNewUserFlow = window.location.href.includes(
				'fundraising/country'
			);
			const response: any = isNewUserFlow
				? await this._accountService.getClientSecret()
				: await this._accountService.getClientSecretExistingUser();

			this.responseData = response;
			const clientSecret = this.responseData?.data?.response?.client_secret;
			this.platform = this.responseData?.data?.platform;

			if (this.platform === 'EU') {
				this.stripeKey = environment.STRIPE_PUBLISHABLE_KEY_EU;
			} else {
				this.stripeKey = environment.STRIPE_PUBLISHABLE_KEY_US;
			}
			if (!clientSecret) {
				throw new Error('Client secret not found in the response');
			}
			return clientSecret;
		} catch (error: any) {
			console.error('Error fetching client secret:', error.message);
			throw new Error('Failed to fetch client secret');
		}
	}
}
